import { ReactSVG } from "react-svg";
import { Contact } from "services/api/contacts/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";
import TableIcon from "ui/components/Table/TableSearch/components/TableIcon";

const handleEmailClick = (e: React.MouseEvent, email: string) => {
  e.stopPropagation();
  e.preventDefault();
  window.location.href = `mailto:${email}`;
};

const handlePhoneClick = (e: React.MouseEvent, phone: string) => {
  e.stopPropagation();
  e.preventDefault();
  window.location.href = `tel:${phone}`;
};

export const WAREHOUSE_CONTACT_SEARCH_COLUMNS = (
  t: (key: string) => string,
): Column[] => [
  {
    title: "",
    key: "warehouse_contact_person",
    alwaysVisible: true,
    field: "",
    type: ColumnTypes.custom,
    render: (row: Contact) => {
      const initials = `${row.firstName?.charAt(0) ?? ""}${row.lastName?.charAt(0) ?? ""}`;
      const imageUrl = row.pictures?.[0]?.url ?? null;
      return (
        <div className="inline-flex gap-3 items-center text-md font-medium truncate">
          <TableIcon imageUrl={imageUrl} initials={initials} />
          <span>{row.firstName} {row.lastName}</span>
        </div>
      );
    },
  },
  {
    title: t("admin.fleet.warehouse.detail.contact.jobtitle"),
    key: "warehouse_contact_job",
    field: "",
    type: ColumnTypes.custom,
    render: (row: Contact) => (
      <span className="text-sm text-slate-600">{row.jobTitle ?? "-"}</span>
    ),
  },
  {
    title: t("admin.fleet.warehouse.detail.contact.email"),
    key: "warehouse_contact_email",
    field: "",
    type: ColumnTypes.custom,
    render: (row: Contact) => (
      <div>
        {row.primaryContactEmail ? (
          <span
            onClick={(e) => handleEmailClick(e, row.primaryContactEmail!.emailAddress)}
            className="inline-flex items-center gap-1.5 text-md font-medium truncate text-sky-600 hover:text-sky-700 cursor-pointer"
          >
            <ReactSVG src="/media/icons/email.svg" className="w-4 h-4 stroke-sky-500 shrink-0" />
            {row.primaryContactEmail.emailAddress}
          </span>
        ) : (
          <span className="text-sm text-slate-600">-</span>
        )}
      </div>
    ),
  },
  {
    title: t("admin.fleet.warehouse.detail.contact.phone"),
    key: "warehouse_contact_phone",
    field: "",
    type: ColumnTypes.custom,
    render: (row: Contact) => (
      <div>
        {row.primaryContactPhone ? (
          <span
            onClick={(e) => handlePhoneClick(e, row.primaryContactPhone!.phoneNumber)}
            className="inline-flex items-center gap-1.5 text-md font-medium truncate text-sky-600 hover:text-sky-700 cursor-pointer"
          >
            <ReactSVG src="/media/icons/phone.svg" className="w-4 h-4 stroke-sky-500 shrink-0" />
            {row.primaryContactPhone.phoneNumber}
          </span>
        ) : (
          <span className="text-sm text-slate-600">-</span>
        )}
      </div>
    ),
  },
];
